import classcat from "classcat";
import React from "react";

import { IconArrowDown, Spinner } from "@touchtech/web-baselayer-ui";

import CollectionStyleItem from "@is/components/CollectionStyleItem";
import DrawerActionButton, {
  ActionButtonVariant,
} from "@is/components/DrawerActionButton/DrawerActionButton";
import { CollectionStyleItemVariant } from "@is/constants";
import { CollectionStylesResponse } from "@is/types";

import css from "./AllItemsView.module.css";
import useManageAllItemsView from "./hooks/useManageAllItemsView";

type Props = {
  onClose: () => void;
  onGetAllItems: (
    page: number,
    pageSize: number
  ) => Promise<CollectionStylesResponse>;
};

const AllItemsView = ({ onClose, onGetAllItems }: Props) => {
  const { t, styles, isPending, showShowMoreButton, handleShowNextPage } =
    useManageAllItemsView(onGetAllItems);

  return (
    <div className={css.container}>
      <DrawerActionButton
        onSecondaryButtonClick={onClose}
        secondaryVariant={ActionButtonVariant.Back}
      />
      <div className={css.headerName}>
        <h1 className="text-headline-5xl">{t("All items")}</h1>
      </div>
      <div className={css.content}>
        {isPending && (
          <div className={css.spinnerContainer}>
            <Spinner className="text-headline-5xl" />
          </div>
        )}

        {styles.length === 0 && !isPending && (
          <div className={css.subtitle}>
            {t("You have not added any items to your collections.")}
          </div>
        )}

        {styles.length && !isPending ? (
          <div className={css.collection}>
            {styles.map((favorite, index) => (
              <CollectionStyleItem
                key={`${favorite.styleId}-${favorite.variantId}`}
                index={index}
                collectionStyle={favorite}
                variant={CollectionStyleItemVariant.IN_ALL_ITEMS}
              />
            ))}

            {showShowMoreButton && (
              <button
                className={classcat(["text-label-xl", css.showMore])}
                onClick={handleShowNextPage}
              >
                <IconArrowDown />
                {t("Show more")}
              </button>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AllItemsView;
